import type { ButtonTheme } from '../../components/primitives/buttons'
import { baseColors, fonts } from '../dwa-base'

const buttonTheme: ButtonTheme = {
  button: [
    {
      style: {
        marginTop: 0,
        borderRadius: 5,
        borderWidth: 0,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 2,
        paddingBottom: 2,
        minWidth: 64,
        height: 34,
        width: 'auto',
      },
    },
    {
      size: 'xs',
      style: {
        minWidth: 54,
        height: 26,
      },
    },
    {
      layout: 'inline',
      style: {
        minWidth: 'auto',
      },
    },
    {
      state: 'focused',
      style: {
        outlineColor: baseColors.blue2,
        outlineStyle: 'solid',
        outlineWidth: 4,
      },
    },
    {
      decoration: 'positive',
      style: { backgroundColor: baseColors.blue },
    },
    {
      decoration: 'positive',
      state: 'hovered',
      style: { backgroundColor: baseColors.blue1 },
    },
    {
      decoration: 'positive',
      state: 'active', // pressed
      style: { backgroundColor: baseColors.blue2 },
    },
    {
      decoration: 'positive',
      state: 'disabled',
      style: { backgroundColor: baseColors.blue3 },
    },
    {
      decoration: 'danger',
      style: { backgroundColor: baseColors.red },
    },
    {
      decoration: 'danger',
      state: 'hovered',
      style: { backgroundColor: baseColors.red1 },
    },
    {
      decoration: 'danger',
      state: 'active', // pressed
      style: { backgroundColor: baseColors.red2 },
    },
    {
      decoration: 'danger',
      state: 'disabled',
      style: { backgroundColor: baseColors.red3 },
    },
    {
      decoration: 'textOnly',
      style: { backgroundColor: 'transparent' },
    },
    {
      decoration: 'textOnly',
      state: 'active',
      style: { backgroundColor: baseColors.white2 },
    },
    {
      decoration: 'secondary',
      style: {
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderColor: baseColors.blue,
      },
    },
    {
      decoration: 'secondary',
      state: 'hovered',
      style: {
        borderColor: baseColors.blue1,
      },
    },
    {
      decoration: 'secondary',
      state: 'active',
      style: {
        borderColor: baseColors.blue2,
        backgroundColor: baseColors.white2,
      },
    },
    {
      decoration: 'secondary',
      state: 'disabled',
      style: {
        borderColor: baseColors.blue3,
      },
    },
    {
      decoration: 'danger-secondary',
      style: {
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderColor: baseColors.red,
      },
    },
    {
      decoration: 'danger-secondary',
      state: 'hovered',
      style: {
        borderColor: baseColors.red1,
        backgroundColor: baseColors.red4,
      },
    },
    {
      decoration: 'danger-secondary',
      state: 'active',
      style: {
        borderColor: baseColors.red2,
        backgroundColor: baseColors.red4,
      },
    },
    {
      decoration: 'danger-secondary',
      state: 'disabled',
      style: {
        borderColor: baseColors.red3,
      },
    },
  ],
  text: [
    {
      style: {
        fontSize: fonts.defaultSize,
        fontWeight: '700',
        color: baseColors.blue,
        fontFamily: fonts.defaultBold,
        textTransform: 'uppercase',
      },
    },
    {
      size: 'xs',
      style: { fontSize: 10 },
    },
    { state: 'disabled', style: { color: baseColors.white1 } },
    {
      decoration: 'positive',
      style: { color: baseColors.white },
    },
    {
      decoration: 'danger',
      style: { color: baseColors.white },
    },
    {
      decoration: 'textOnly',
      state: 'hovered',
      style: { color: baseColors.blue1 },
    },
    {
      decoration: 'textOnly',
      state: 'active',
      style: { color: baseColors.blue2 },
    },
    {
      decoration: 'textOnly',
      state: 'disabled',
      style: { color: baseColors.blue3 },
    },
    {
      decoration: 'secondary',
      state: 'hovered',
      style: { color: baseColors.blue1 },
    },
    {
      decoration: 'secondary',
      state: 'active',
      style: { color: baseColors.blue2 },
    },
    {
      decoration: 'secondary',
      state: 'disabled',
      style: { color: baseColors.blue3 },
    },
    {
      decoration: 'danger-secondary',
      style: { color: baseColors.red },
    },
    {
      decoration: 'danger-secondary',
      state: 'hovered',
      style: { color: baseColors.red1 },
    },
    {
      decoration: 'danger-secondary',
      state: 'active',
      style: { color: baseColors.red2 },
    },
    {
      decoration: 'danger-secondary',
      state: 'disabled',
      style: { color: baseColors.red3 },
    },
  ],
  iconContainer: [
    {
      style: {
        width: fonts.defaultSize,
        height: fonts.defaultSize,
        alignSelf: 'center',
      },
    },
    {
      size: 'xs',
      style: {
        width: 12,
        height: 12,
      },
    },
  ],
}

export default buttonTheme
